import { trackEditCandidateExperienceClickedEvent } from '../../../utils/events/addCandidateEvents';
import FormStep from './FormStep';
import {
  Stack,
  TextField,
  FieldLabel,
  Inline,
  Dropdown,
} from 'braid-design-system';
import { ADD_CANDIDATE_FORM_FIELD_NAMES } from './AddCandidateForm';
import translations from './.vocab/';
import { useTranslations } from '@vocab/react';
import useTimeInRole from './hooks/useTimeInRole';

interface Props {
  editable: boolean;
  mostRecentJobTitle: any;
  mostRecentCompanyName: any;
  timeInRoleYears: any;
  timeInRoleMonths: any;
}

const StepThree = ({
  editable,
  mostRecentJobTitle,
  mostRecentCompanyName,
  timeInRoleYears,
  timeInRoleMonths,
}: Props) => {
  const { t } = useTranslations(translations);
  const { getTimeInRole, populateTimeInRoleOptions } = useTimeInRole();
  const displayValues = [
    { value: mostRecentJobTitle.value, alt: t('Current job title') },
    { value: mostRecentCompanyName.value, alt: t('Current company') },
    {
      value: getTimeInRole(timeInRoleYears.value, timeInRoleMonths.value),
      alt: t('Time in role'),
    },
  ];

  return (
    <FormStep
      editable={editable}
      displayValues={displayValues}
      onEditClickTracking={trackEditCandidateExperienceClickedEvent}
    >
      <Stack space="medium">
        <TextField
          id={ADD_CANDIDATE_FORM_FIELD_NAMES.MOST_RECENT_JOB_TITLE}
          label={t('Current job title')}
          secondaryLabel={t('Optional')}
          value={mostRecentJobTitle.value}
          onChange={mostRecentJobTitle.onChange}
          autoFocus
          reserveMessageSpace
          placeholder={t('Enter current job title')}
        />

        <TextField
          id={ADD_CANDIDATE_FORM_FIELD_NAMES.MOST_RECENT_COMPANY_NAME}
          label={t('Current company')}
          secondaryLabel={t('Optional')}
          value={mostRecentCompanyName.value}
          onChange={mostRecentCompanyName.onChange}
          reserveMessageSpace
          placeholder={t('Enter current company name')}
        />

        <Stack space="small">
          <FieldLabel
            htmlFor={ADD_CANDIDATE_FORM_FIELD_NAMES.TIME_IN_ROLE_YEARS}
            label={t('Time in role')}
            secondaryLabel={t('Optional')}
          />
          <Inline space="medium">
            <Dropdown
              id={ADD_CANDIDATE_FORM_FIELD_NAMES.TIME_IN_ROLE_YEARS}
              name={ADD_CANDIDATE_FORM_FIELD_NAMES.TIME_IN_ROLE_YEARS}
              placeholder={t('Years')}
              label={t('Years')}
              value={timeInRoleYears.value}
              onChange={timeInRoleYears.onChange}
            >
              {populateTimeInRoleOptions(21, 'year', true).map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Dropdown>
            <Dropdown
              id={ADD_CANDIDATE_FORM_FIELD_NAMES.TIME_IN_ROLE_MONTHS}
              name={ADD_CANDIDATE_FORM_FIELD_NAMES.TIME_IN_ROLE_MONTHS}
              placeholder={t('Months')}
              label={t('Months')}
              value={timeInRoleMonths.value}
              onChange={timeInRoleMonths.onChange}
            >
              {populateTimeInRoleOptions(11, 'month').map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Dropdown>
          </Inline>
        </Stack>
      </Stack>
    </FormStep>
  );
};

export default StepThree;
